var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 100 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.995 20.825L87.12 11.675C86.3131 11.157 85.4357 10.7579 84.515 10.49C83.598 10.1932 82.6434 10.0282 81.68 10H47.5L51.505 35H81.68C82.5 35 83.525 34.815 84.51 34.51C85.495 34.205 86.445 33.785 87.115 33.33L98.99 24.17C99.665 23.715 100 23.11 100 22.5C100 21.89 99.665 21.285 98.995 20.825ZM42.5 0H37.5C36.837 0 36.2011 0.263392 35.7322 0.732233C35.2634 1.20107 35 1.83696 35 2.5V20H18.32C17.49 20 16.47 20.185 15.485 20.495C14.495 20.795 13.55 21.21 12.88 21.675L1.005 30.825C0.33 31.28 0 31.89 0 32.5C0 33.105 0.33 33.71 1.005 34.175L12.88 43.335C13.55 43.79 14.495 44.21 15.485 44.51C16.47 44.815 17.49 45 18.32 45H35V87.5C35 88.163 35.2634 88.7989 35.7322 89.2678C36.2011 89.7366 36.837 90 37.5 90H42.5C43.163 90 43.7989 89.7366 44.2678 89.2678C44.7366 88.7989 45 88.163 45 87.5V2.5C45 1.83696 44.7366 1.20107 44.2678 0.732233C43.7989 0.263392 43.163 0 42.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.3650e88f90c98d10c509ee385e7d3eb9.svg";
export { ForwardRef as ReactComponent };